import { render, staticRenderFns } from "./addCalcSalary.vue?vue&type=template&id=f1664d5c&scoped=true&"
import script from "./addCalcSalary.vue?vue&type=script&lang=js&"
export * from "./addCalcSalary.vue?vue&type=script&lang=js&"
import style0 from "./addCalcSalary.vue?vue&type=style&index=0&id=f1664d5c&prod&lang=scss&scoped=true&"
import style1 from "./addCalcSalary.vue?vue&type=style&index=1&id=f1664d5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1664d5c",
  null
  
)

export default component.exports